module.exports = function (confirmationDialogService) {
    return {
        restrict: 'E',
        link(scope) {
            scope.confirmationDialog = confirmationDialogService;

            //Click Handlers
            scope.continue = confirmationDialogService.resolveDialog.bind(confirmationDialogService, true);
            scope.cancel = confirmationDialogService.resolveDialog.bind(confirmationDialogService, false);
        },
        template: require('./confirmation-dialog-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/confirmation-dialog/confirmation-dialog-directive.js
 **/